import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { SupplierApi } from '../api/supplier.api';
import { Supplier, SupplierAccessSave } from '../models/supplier.model';

@Injectable({ providedIn: 'root' })
export class SupplierService {
  private readonly _api = inject(SupplierApi);

  public getAll(buyerId: number): Observable<Supplier[]> {
    return this._api.getAll(buyerId);
  }

  public saveAccess(data: SupplierAccessSave): Observable<void> {
    return this._api.saveAccess(data).pipe(map(() => undefined));
  }
}
